import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { SecurityApiService } from '@shared/services/security-api.service';
import { ToastrService } from 'ngx-toastr';
import { from } from 'rxjs';
import { ShareholderRelationshipDetails } from '@models/relationships/relationship';
import { nonBeneficialOwnerLabel } from "../../../../forms/asic-forms/shares/constants/non-beneficial-owner-label";
import { InlineEditInputComponent } from '@shared/controls/inline-edit-input/inline-edit-input.component';
import { SpanWithOpenIconComponent } from '@shared/components/commons/span-with-open-icon/span-with-open-icon.component';

@Component({
  selector: 'app-beneficial-owner',
  standalone: true,
  templateUrl: './beneficial-owner.component.html',
  styleUrl: './beneficial-owner.component.scss',
  imports: [
    InlineEditInputComponent,
    SpanWithOpenIconComponent
  ]
})
export class BeneficialOwnerComponent {
  @Input({ required: true }) details!: ShareholderRelationshipDetails;
  @Input({ required: true }) relationshipIds!: string[];
  @Input() showOpenIcon = false;
  @Input() controlLike = false;

  @Output() onDataSaved = new EventEmitter<string>();

  securityService = inject(SecurityApiService);
  toastr = inject(ToastrService);

  readonly nonBeneficialOwnerLabel = nonBeneficialOwnerLabel;

  updateBeneficialOwner(relationshipIds: string[]) {
    return (newBOName: string) => {
      return from(relationshipIds.map(relationshipId => {
         this.securityService.updateBeneficialOwner(relationshipId, newBOName)
        .subscribe({
          next: () => {
            this.details.beneficialOwner = newBOName;
            this.toastr.success('Beneficial owner updated');
            this.onDataSaved.emit(newBOName);
          },
          error: () => {
            this.toastr.error('Failed to update beneficial owner');
          }
        })
      }));
    };
  }

}
